<template>

<div>
  <b-card>
    <h5>Cari data</h5>
    <validation-observer ref="filterValidation">
        <div class="form-group row">
          <label class="col-2 col-form-label">Cabang</label>
          <div class="col-3">
            <validation-provider #default="{ errors }" name="BranchId">
              <BranchListComponent
                :value="filter.branchId"
                @value="filter.branchId = $event"
                :errors="errors"
              />
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-2 col-form-label">Nama Karyawan</label>
          <div class="col-3">
            <validation-provider #default="{ errors }" name="NameEmployee" rules="required">
              <EmployeeListComponent
                :value="filter.employeeId"
                @value="filter.employeeId = $event"
                :isLoadingEmployeeList="isLoadingEmployeeList"
                filterBy="branch"
                :filterValue="filterValue"
                :errors="errors"
              />
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
        <label class="col-2 col-form-label">Tanggal</label>
        <div class="col-3">
          <validation-provider #default="{ errors }" name="startDate" rules="required">
            <b-form-input v-model="filter.startDate" class="form-control" type="date"></b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </div>
        <div class="col-0 d-flex align-items-center">
          <span>s/d</span>
        </div>
        <div class="col-3">
          <validation-provider #default="{ errors }" name="endDate" rules="required">
            <b-form-input v-model="filter.endDate" class="form-control" type="date"></b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </div>
      </div>
    </validation-observer>

    <b-row class="mb-1">
      <b-col style="display: flex;">
        <b-button
          class="px-2 d-inline align-items-center mr-2"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="filterData()">
          Cari
        </b-button>
        <!-- <b-button
          class="px-2 d-inline align-items-center"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="light"
          @click="resetFilter()">
          Reset
        </b-button> -->
        <b-overlay :show="isDownload" spinner-small rounded="sm">
          <b-button
            class="px-2 d-inline align-items-center"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            @click="DownloadExport()"
            >
            Export
          </b-button>
        </b-overlay>
      </b-col>
    </b-row>

  </b-card>

<b-card>

  <!-- <b-row class="mb-1">
    <b-col class="text-right">
      <b-button
        v-b-modal.form-attendance-modal
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="cleanUpForm()">
        Tambah
      </b-button>
    </b-col>
  </b-row> -->

  <BaseTable
    :fields="fields"
    :items="items"
    :loading="loading"
    :rows="pagination.total"
    :perPage="filter.size"
    :currentPage="filter.page"
    :handle-page-change="handlePageChange"
    :detail-item="detailItem"
    :edit-item="editItem"
    :delete-item="deleteItem"
    hide-delete
    hide-update
  />

  <FormAttendance
    :page-title="pageTitle"
    :loading="loading"
    :edit-id="editId"
    :create-item="createItem"
    :update-item="updateItem"
    :formPayload="formPayload"
    @formPayloadParamSystem="getPayload($event)" />

</b-card>

</div>

</template>

<script>
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import { AttendanceService } from '@/services/attendance.service';
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { BOverlay,BCard, BRow, BCol, BButton, BFormInput, BSpinner } from "bootstrap-vue";
import { successNotification, errorNotification } from "@/auth/utils";
import vSelect from "vue-select";

import BaseTable from "@/components/BaseTable.vue";
import BranchListComponent from "@/components/Base/BranchListComponent.vue";
import EmployeeListComponent from "@/components/Base/EmployeeListComponent.vue";
import FormAttendance from "@/components/Attendance/FormAttendance.vue";

export default {
  name: 'AttendancePage',
  components: {
    BaseTable,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BOverlay,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BranchListComponent,
    EmployeeListComponent,
    FormAttendance,
    required
  },
  directives: {
    Ripple,
  },

  watch: {
    'filter.page'() {
      this.fetchData()
    },
    'filter.branchId'(value) {
      window.console.log(value);
      // this.isLoadingEmployeeList = false
      // this.filterValue = null
      // if (value !== null) {
      //   this.isLoadingEmployeeList = true
      //   this.filterValue = value
      // }
    },
  },

  setup () {
    return {
      successNotification,
      errorNotification,
      BaseTable
    };
  },

  data () {
    return {
      key: 'attendance',
      pageTitle: 'Absensi',
      items: [],
      detail: Object,
      error: false,
      loading: false,
      pagination: {
        total: 0
      },
      isDownload: false,
      filter: {
        branchId: "",
        employeeId: "",
        startDate: "",
        endDate: "",
        page: 1,
        size: 10,
        attendanceColumn: 'ATTENDANCE_DATE',
        sortDirection: 'DESC',
      },
      fields: [
        {
          key: "no",
          label: "No",
          width: '50px',
        },
        {
          key: "employee",
          label: "Nama Karyawan",
        },
        {
          key: "attendanceDate",
          label: "Tgl",
        },
        {
          key: "attendanceType",
          label: "Jenis",
        },
        {
          key: "day",
          label: "Hari",
        },
        {
          key: "wfh",
          label: "Is WFH",
        },
        {
          key: "startTime",
          label: "Masuk",
        },
        {
          key: "endTime",
          label: "Pulang",
        },
        {
          key: "countTime",
          label: "Efektif",
        },
        {
          key: "actions",
          label: "Aksi",
          width: '200px'
        },
      ],
      editId: null,
      formPayload: Object,
      isLoadingEmployeeList: false,
      filterValue: null,
    }
  },

  methods: {
    cleanUpForm() {
      this.editId = null;
      this.formPayload = {
        employeeId: "",
        attendanceDate: "",
        day: "",
        description: "",
      };
    },
    filterData() {
      if (this.filter.branchId === undefined) {
        return errorNotification(this, "Oops!", "Branch Required");
      }
      this.$refs.filterValidation.validate().then((result) => {
        if (result) {
          this.fetchData()
        }
      });
    },
    // resetFilter() {
    //   this.branchId = "",
    //   this.employeeId = "",
    //   this.startDate = "",
    //   this.endDate = "",
    //   this.page = 1,
    //   this.size = 10
    //   this.fetchData()
    // },
    async fetchData () {
      this.prepareFilter()
      this.loading = true;
      this.items = [];
      try {
        const { data } = await AttendanceService.findAll(this.filter)

        this.items = data.content
        this.pagination.total = data.total
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    DownloadExport () {
      window.console.log(this.filter);
      this.isDownload = true;
      this.$http.get(`/employee-activity/employee-attendance/download`, {'responseType':'blob',params: this.filter})
          .then((result) => {
            window.console.log(result);
            const blob = new Blob([result.data],{type: result.data.type});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Report Absensi ${this.filter.startDate === undefined ? '':this.filter.startDate} ${this.filter.endDate === undefined ? '':this.filter.endDate}`;
            link.click();
            URL.revokeObjectURL(link.href);
            this.isDownload = false;
          })
          .catch((e) => {
            window.console.log(e);
            this.isDownload = false;
          });
    },
    detailItem(item) {
      this.detail = item;
      const id = item.id
      this.$router.push({name: "attendance.show", params: { id }});
    },
    editItem(item) {
      this.editId = item.id;
      this.formPayload = {
        employeeId: item.employee ? item.employee.employeeId : item.employee,
        attendanceDate: item.attendanceDate,
        day: item.day,
        description: item.description,
      };
      this.showFormModal()
    },
    async createItem() {
      this.loading = true

      try {
        await AttendanceService.create(this.preparePayload())
        successNotification(this, "Success", `${this.pageTitle} berhasil dibuat!`);
        this.hideFormModal()
        this.fetchData()
      } catch (e) {
        this.error = e.message
        errorNotification(this, "Oops!", e.message);
      } finally {
        this.loading = false
      }
    },
    async updateItem() {
      this.loading = true

      try {
        await AttendanceService.update(this.editId, this.preparePayload())
        successNotification(this, "Success", `${this.pageTitle} berhasil diubah!`);
        this.hideFormModal()
        this.fetchData()
      } catch (e) {
        this.error = e.message
        errorNotification(this, "Oops!", e.message);
      } finally {
        this.loading = false
      }
    },
    deleteItem(item) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await AttendanceService.delete(item.id)
            successNotification(this, "Success", `${this.pageTitle} berhasil dihapus!`);
            this.hideFormModal()
            this.fetchData()
          } catch (e) {
            this.error = e.message
            errorNotification(this, "Oops!", e.message);
          } finally {
            this.loading = false
          }
        }
      });
    },
    getPayload(value) {
      if (value) {
        this.formPayload = value;
      }
    },
    prepareFilter() {
      for (const key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != null
        ) {
          if (this.filter[key] == null || this.filter[key] == "") {
            delete this.filter[key]
          }
        }
      }
      return this.filter
    },
    preparePayload() {
      const form = new FormData();
      for (const key in this.formPayload) {
        if (
          this.formPayload.hasOwnProperty(key) &&
          this.formPayload[key] != null
        ) {
          form.append(key, this.formPayload[key]);
        }
      }

      return form;
    },
    showFormModal() {
      this.$bvModal.show(`form-${this.key}-modal`);
    },
    hideFormModal() {
      this.$bvModal.hide(`form-${this.key}-modal`);
    },
    handlePageChange(value) {
      this.loading = true
      this.filter.page = value;
    },
  },

  created () {
    this.fetchData()
  }

}

</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
